import { Action } from 'redux';

import { IOrderClause } from '../../../ts/ServerApi/types/IOrderClause';
import { SortContent } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SortContentAction extends Action {
  order: IOrderClause[];
}

export function sortContent(order: IOrderClause[]): SortContentAction {
  return {
    type: SortContent,
    order
  };
}

export const isSortContentAction = isActionFactory<SortContentAction>(SortContent);
